import {call, put, takeLatest, fork, all, delay,} from 'redux-saga/effects';
import * as Types from '../constants/Types';
import * as VinWonderPriceService from './../services/VinWonderPriceService';

import i18n from '../constants/initLng';
import * as Func from "../helpers/functions";
import {PATHS, SAGA_DELAY_TIMEOUT} from '../constants/Define';
import { parseListRequestParamsCameo } from '../utils/commonUtils';
import {
    setListVinWonderPrices as setListVinWonderPricesAction,
    setVinWonderPriceDetail as setVinWonderPriceDetailAction
} from './../actions/VinWonderPriceAction';
import history from './../helpers/history';

function* getListVinWonderPrice() {
    yield takeLatest(Types.VIN_WONDER_PRICE_LIST_ACTION, Func.sagaWrapper(function* (action) {
        const params = parseListRequestParamsCameo(action.filters || {})
        yield delay(SAGA_DELAY_TIMEOUT);
        const result = yield call(VinWonderPriceService.getVinWonderPrice, params);
        yield put(setListVinWonderPricesAction(result));
    }, errorHandleVinWonderPrice(Types.VIN_WONDER_PRICE_LIST_FAIL)))
}

function* getVinWonderPriceDetail() {
    yield takeLatest(Types.VIN_WONDER_PRICE_DETAIL_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(VinWonderPriceService.getVinWonderPriceDetail, action.id);
        yield put(setVinWonderPriceDetailAction(result));
    }, errorHandleVinWonderPrice(Types.VIN_WONDER_PRICE_DETAIL_FAIL)))
}

function* updateVinWonderPriceDetail() {
    yield takeLatest(Types.VIN_WONDER_PRICE_DETAIL_UPDATE_ACTION, Func.sagaWrapper(function* (action) {
        Func.sagaLoadingMessage(action);
        yield call(VinWonderPriceService.updateVinWonderPriceDetail, action.vinWonderPrice);
        successHandleVinWonderPrice(action, action.vinWonderPrice.name);
        yield put(setVinWonderPriceDetailAction(action.vinWonderPrice));
        const path = Func.getPathWithParams(PATHS.VIN_WONDER_PRICE.LIST.path, { vin_wonder_id: action.vinWonderPrice.vinWonderId })
        history.push(path);
        history.go();
    }, errorHandleVinWonderPrice(Types.VIN_WONDER_PRICE_DETAIL_FAIL)))
}

function* createVinWonderPriceDetail() {
    yield takeLatest(Types.VIN_WONDER_PRICE_DETAIL_CREATE_ACTION, Func.sagaWrapper(function* (action) {
        Func.sagaLoadingMessage(action);
        const result = yield call(VinWonderPriceService.createVinWonderPriceDetail, action.vinWonderPrice);
        successHandleVinWonderPrice(action, action.vinWonderPrice.name);
        yield put(setVinWonderPriceDetailAction(result));
        const path = Func.getPathWithParams(PATHS.VIN_WONDER_PRICE.LIST.path, { vin_wonder_id: action.vinWonderPrice.vinWonderId })
        history.push(path);
        history.go();
    }, errorHandleVinWonderPrice(Types.VIN_WONDER_PRICE_DETAIL_FAIL)))
}

function* deleteVinWonderPriceDetail() {
    yield takeLatest(Types.VIN_WONDER_PRICE_DETAIL_DELETE_ACTION, Func.sagaWrapper(function* (action) {
        Func.sagaLoadingMessage(action);
        yield call(VinWonderPriceService.deleteVinWonderPriceDetail, action.vinWonderPrice);
        Func.sagaSuccessMessage({
            action,
            message: `${i18n.t('notification.removeSuccess')}`,
        });
        const params = parseListRequestParamsCameo(action.filters || {});
        params.filters.vinWonderId = action.vinWonderPrice.vinWonderId;
        const resultList = yield call(VinWonderPriceService.getVinWonderPrice, params.filters);
        yield put(setListVinWonderPricesAction(resultList));
    }, errorHandleVinWonderPrice(Types.VIN_WONDER_PRICE_DETAIL_FAIL)));
}

function successHandleVinWonderPrice(action, value) {
    return Func.sagaSuccessMessage({
        action,
        message: `${i18n.t('notification.createSuccess')}`,
        description: `${i18n.t('item.vinWonderPrice.title')} "${value}"`
    })
}


function errorHandleVinWonderPrice(errorActionType) {
    return Func.sagaErrorHandler(function* (e) {
        yield put({ type: errorActionType })
    }, 'vinWonderPrice');
}

export function* vinWonderPriceSaga() {
    yield all([
        fork(getListVinWonderPrice),
        fork(getVinWonderPriceDetail),
        fork(updateVinWonderPriceDetail),
        fork(createVinWonderPriceDetail),
        fork(deleteVinWonderPriceDetail),
    ])
}
